export function scrollTo(el, offset, callback) {
  const fixedOffset = offset.toFixed()
  const onScroll = () => {
    if (el.scrollTop.toFixed() === fixedOffset) {
      el.removeEventListener('scroll', onScroll)
      callback()
    }
  }
  el.addEventListener('scroll', onScroll)
  onScroll()
  el.scrollTo({
    top: offset,
    behavior: 'smooth',
  })
}
